import { SnackBarData } from './snackbar-data';
export const SHOW_SNACKBAR = '[Snackbar] General message';

export const ShowSnackBar = (data: SnackBarData | { message: string }) => ({
  type: SHOW_SNACKBAR,
  payload: data instanceof SnackBarData ? data : new SnackBarData(data.message),
});
